import { DebugLog } from '../core/DebugLog.js';

/**
 * Handles XP gain and level-up logic.
 */
export class LevelSystem {
  /**
   * Calculate XP required to reach the next level.
   * @param {number} level - Current level
   * @returns {number} XP needed for next level
   */
  static xpForLevel(level) {
    return 50 + level * 30;
  }

  /**
   * Add XP to the game state. Handles level-ups (possibly multiple).
   * @param {object} gameState - The GameState singleton
   * @param {number} amount - XP to add
   * @returns {{ leveledUp: boolean, newLevel: number, levelsGained: number }}
   */
  static addXP(gameState, amount) {
    gameState.xp += amount;
    let leveledUp = false;
    let levelsGained = 0;

    while (gameState.xp >= gameState.xpToNext) {
      gameState.xp -= gameState.xpToNext;
      gameState.level++;
      gameState.statPoints += 2;
      // Grant 1 skill point per level (M28)
      if (gameState.skillPoints !== undefined) {
        gameState.skillPoints++;
      }
      gameState.xpToNext = LevelSystem.xpForLevel(gameState.level);
      leveledUp = true;
      levelsGained++;
      DebugLog.info('LevelSystem', `Level up! Now level ${gameState.level}, ${gameState.statPoints} stat points available`);
    }

    return { leveledUp, newLevel: gameState.level, levelsGained };
  }

  /**
   * Allocate a stat point to a given stat.
   * @param {object} gameState - The GameState singleton
   * @param {string} stat - 'maxHp' | 'damage' | 'speed' | 'defense'
   * @returns {boolean} True if a point was allocated
   */
  static allocateStat(gameState, stat) {
    if (gameState.statPoints <= 0) return false;

    const valid = ['maxHp', 'damage', 'speed', 'defense'];
    if (!valid.includes(stat)) return false;

    gameState.statPoints--;
    gameState.statAllocations[stat]++;
    DebugLog.info('LevelSystem', `Allocated point to ${stat} (now ${gameState.statAllocations[stat]})`);
    return true;
  }
}
